/*----------------------------------------------------------------------------*\
 FINDER
 Initialisation of the folder structure.
 Plugin used: http://docs.dhtmlx.com/tree__index.html
 \*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */
/*global dhtmlXTreeObject */



/*  Component
    Tree component docs : http://docs.dhtmlx.com/tree__index.html
 \*----------------------------------------------------------------------------*/

oy.finder = {
    init: function (onSelectCallBack, onDraggedCallback, onLoadedCallback) {
        if (oy.cutsMustard) {
            this.initTree(document, onSelectCallBack, onDraggedCallback, onLoadedCallback);
            this.orderTree(document);
        }
    },

    initTree: function ($context, onSelectCallBack, onDraggedCallback, onLoadedCallback, onCheckCallBack) {
        var $container = $context.querySelector('.js--finder');
        if ($container) {
            var $treeWrap = $container.querySelector('.js--finder__tree');
            var xmlFileUrl = $container.dataset.ajaxUrl;
            var imagesUrl = $container.dataset.imagesUrl;
            var type = $container.getAttribute('data-finder-type');

            if (xmlFileUrl) {
                // init the tree
                var tree = new dhtmlXTreeObject($treeWrap, '100%', '100%', 0);

                // turn off caching of ajax requests, otherwise the tree will add a querystring parameter in the form of dhxr1313456=1
                window.dhx4.ajax.cache = true;

                // initialise custom images folder
                tree.setImagesPath(imagesUrl); // dynamic, html-based folder
                // tree.setImagesPath('/static/public/js/lib/dhtmlxtree.502/imgs/dhxtree_material/'); // original folder

                // enable lines between related items
                tree.enableTreeLines(true);

                //set custom images for tree-lines
                tree.setImageArrays('plus', 'plus2.svg', 'plus3.svg', 'plus4.svg', 'plus1.svg', 'plus5.svg');
                tree.setImageArrays('minus', 'minus2.svg', 'minus3.svg', 'minus4.svg', 'minus1.svg', 'minus5.svg');
                tree.setImageArrays('line', 'line2.svg', 'line3.svg', 'line4.svg', 'blank.gif', 'blank.gif', 'line1.svg');


                // use CSS for sizing
                tree.setIconSize(false, false);

                // set auto load in select
                tree.setXMLAutoLoading(xmlFileUrl);

                // load json
                tree.load(xmlFileUrl, function () {
                    // initialsed
                    if(onLoadedCallback) {
                        onLoadedCallback(tree);
                    }
                    tree.showItemSign(999, false);
                    if (type === 'deletion') {
                        tree.disableCheckbox(999, true);
                    }
                }, 'xml');

                // attach on select event
                tree.attachEvent('onSelect', function(id){
                    if(onSelectCallBack) {
                        onSelectCallBack(id, tree.getItemText(id));
                    }
                });

                if (type !== 'deletion') {
                    // enable drag and drop
                    tree.enableDragAndDrop(true, false);

                    // attach on drag event
                    tree.attachEvent('onDrop', function(sourceId, targetId) {
                        if(onDraggedCallback) {
                            return onDraggedCallback(sourceId, targetId);
                        }
                        return false;
                    });
                }

                if (type === 'deletion') {
                    tree.enableCheckBoxes(true, false);
                    tree.enableThreeStateCheckboxes(true);


                    tree.attachEvent('onCheck', function(id, state){
                        tree.setSubChecked(id, state);
                        if(onCheckCallBack) {
                            onCheckCallBack(id, tree.getItemText(id), state);
                        }
                    });
                }


                window.FolderTree = tree;
            }
        }
    },

    orderTree: function($context) {
        var $orderTypes = $context.querySelector('.js--order-tree');
        if ($orderTypes) {
            var $inputs = $orderTypes.querySelectorAll('input');
            for (var i = 0; i < $inputs.length; i++) {
                $inputs[i].addEventListener('change', function () {
                    // get the ordering type:
                    // var orderType = $orderTypes.querySelector('input:checked').value;
                });
            }
        }
    }
};


window.addEventListener('load', function () {
    if(oy.functions.isStyleGuide()) {
        oy.finder.init();
    }
}, false);
